module.exports = __webpack_public_path__ + "img/signals.5f3c64e7.png";